import Vue from 'vue';
import Basic from './Basic/Basic';

const layouts = [
    Basic,
];

// Components that are registered globally.
layouts.forEach(Component => {
    Vue.component(Component.name, Component);
});
